import { I18n } from '../wrappers/I18n';
import Store from '../wrappers/Store';
export const EinvoiceService = {
    isLocaleAllowed() {
        return I18n.c('order.allowEinvoice');
    },
    isModuleEnabled(modules) {
        modules = modules ?? Store.get('modules');
        return !!modules?.einvoices;
    },
    isApiKeySetup(venue) {
        venue = venue ?? Store.get('tenant')?.venue;
        return !!venue?.settings?.einvoice?.api_key;
    },
    isVenueAllowed(venue) {
        venue = venue ?? Store.get('tenant')?.venue;
        if (!venue)
            return false;
        return !!venue.tax_id_number
            && !!venue.registration_number
            && !!venue.city
            && !!venue.postal_number
            && !!venue.country
            && !!venue.bank_account_number;
    },
    isEnabled(venue) {
        return EinvoiceService.isLocaleAllowed() && EinvoiceService.isApiKeySetup(venue);
    },
    isAllowed(venue, modules) {
        return EinvoiceService.isLocaleAllowed() && EinvoiceService.isModuleEnabled(modules) && EinvoiceService.isVenueAllowed(venue);
    },
    einvoiceOnly(venue) {
        venue = venue ?? Store.get('tenant')?.venue;
        return EinvoiceService.isLocaleAllowed() && !!venue?.settings?.noncash_only;
    },
    vatObligations(isAdvance) {
        let obligations = ['by_due_date', 'no_obligation'];
        if (!isAdvance) {
            obligations = ['by_delivery_date', 'by_issue_date', ...obligations];
        }
        return obligations.map(obligation => {
            return {
                value: obligation,
                display: isAdvance && obligation === 'by_due_date'
                    ? I18n.t(`einvoice.vat_obligation.by_due_date_advance`)
                    : I18n.t(`einvoice.vat_obligation.${obligation}`)
            };
        });
    },
};
export default EinvoiceService;
//# sourceMappingURL=EinvoiceService.js.map